var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28A14 14 0 014.1 4.1a14.00071427 14.00071427 0 0119.8 19.8A13.908 13.908 0 0114 28zm-.013-26.033A12 12 0 006 22.928v-.585a.044.044 0 01.005-.017.041.041 0 000-.016A5.2 5.2 0 0111 17h6a5.208 5.208 0 015 5.311v.607a12 12 0 00-8-20.95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5a5 5 0 105 5 5 5 0 00-5-5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackUser);
export default __webpack_public_path__ + "static/media/FeedbackUser.c2b4808c2fe390b0abf8b9749ef91a48.svg";
export { ForwardRef as ReactComponent };